var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle fa-lg icon-button",attrs:{"title":"Detalhar reprovação"},on:{"click":function($event){$event.stopPropagation();return _vm.detalharReprovacao()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }